// import { __App } from "./core";
import { NO_OF_ITEMS } from "../_game/config/Game";

export default class Utils {
  // constructor() {}

  isSet(varistor: any) {
    if (typeof varistor === "undefined" || varistor === null) return false;
    return true;
  }

  getRandomID() {
    return "_" + Math.random().toString(36).substr(2, 10);
  }

  toFloor(_valPosXY: any) {
    _valPosXY.x = Math.floor(_valPosXY.x);
    _valPosXY.y = Math.floor(_valPosXY.y);
  }

  clamp(_var: any, _min: number, _max: number) {
    if (_var < _min) return _min;
    else if (_var > _max) return _max;
    else return _var;
  }

  loadJS(src: string, loadAsync: boolean) {
    return new Promise((resolve) => {
      const ref = window.document.getElementsByTagName("script")[0] as any;
      const script = window.document.createElement("script");
      script.src = src;
      script.async = loadAsync;
      ref.parentNode.insertBefore(script, ref);
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
    });
  }

  randGetBetween = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min)) + min;
  };

  randGenerateArr = (total: any, max: number, exclude?: any): any => {
    let _ret: number[] = [];

    while (_ret.length < total) {
      let _number = this.randGetBetween(1, max);
      if (!_ret.includes(_number)) {
        _ret.push(_number);
      }
    }
    return _ret;
  };

  generateNumberColor(number: number) {
    let _pos = Math.ceil(number / NO_OF_ITEMS);

    switch (_pos) {
      case 1:
        return "game-ball-number-pink";
      case 2:
        return "game-ball-number-yellow";
      case 3:
        return "game-ball-number-purple";
      case 4:
        return "game-ball-number-green";
      case 5:
        return "game-ball-number-dark-red";
      case 6:
        return "game-ball-number-orange";
      case 7:
        return "game-ball-number-green-leaf";
      case 8:
        return "game-ball-number-blue";
      default:
        return "";
    }

    // return '';
  }

  getQueryParams = () => {
    const queryParams = window.location.search.substring(1).split("&");

    const uri = window.location.href.split("?");
    if (uri.length === 2) {
      const vars = uri[1].split("&");
      const getVars: any = {};
      vars.forEach((v) => {
        let tmp: any = v.split("=");
        if (tmp.length === 2) {
          getVars[tmp[0]] = tmp[1];
        }
      });

      return getVars;
    }

    const paramList: any = {};
    for (const param of queryParams) {
      const values = param.split("=");
      paramList[values[0]] = values[1];
    }
    return paramList;
  };
}
